module.exports = __webpack_public_path__ + "e56a5ded9795e4d197cacbd98d159c17.jpg";